"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function AmexSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 20, viewBox: "0 0 30 20" }, props),
        react_1.default.createElement("g", { fill: "none" },
            react_1.default.createElement("path", { fill: "#1976D2", d: "M29.67 17.28c-.052 1.509-1.316 2.69-2.825 2.64h-24c-.728.03-1.438-.232-1.972-.728S.025 18.008 0 17.28V2.75C.052 1.241 1.316.06 2.825.11h24c1.509-.05 2.773 1.131 2.825 2.64l.02 14.53z" }),
            react_1.default.createElement("path", { fill: "#FFF", d: "M13.61 7.375l-1.5 3.095-1.5-3.095H8.705v4.44l-2.12-4.44H5L2.845 12h1.28l.47-1.03H7L7.5 12h2.445V8.56L11.57 12h1.105l1.66-3.365V12h1.215V7.375h-1.94zM5.055 9.96l.72-1.61.755 1.61H5.055zM24.645 9.63l2.2-2.24H25.28l-1.405 1.43L22.5 7.375h-4.84V12h4.685l1.5-1.5 1.42 1.5h1.56l-2.18-2.37zM21.71 11h-2.83v-.895h2.71V9.23h-2.71v-.86h3l1.195 1.255L21.71 11z" })));
}
function Amex(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(AmexSvg, Object.assign({}, svgProps)));
}
exports.default = Amex;
//# sourceMappingURL=Amex.js.map